import React from 'react';
import '../../clients/mobile/styles/MobileClients.css';
import '../ManagementPagination.css';

/**
 * Prev / numbered pages / Next — shared with mobile clients; optional desktop row layout.
 */
export default function MobileManagementPagination({
  totalPages,
  currentPage,
  setCurrentPage,
  totalCount,
  itemsPerPage,
  /** Shown after the total count, e.g. "clients" or "team members" */
  resultsNoun,
  /** Row layout + spacing for desktop management pages */
  desktopBar = false,
}) {
  if (totalPages <= 1) return null;

  const start =
    totalCount === 0 ? 0 : Math.min(totalCount, (currentPage - 1) * itemsPerPage + 1);
  const end = Math.min(totalCount, currentPage * itemsPerPage);

  return (
    <div
      className={`mobile-clients-pagination${desktopBar ? ' mobile-clients-pagination--desktop-bar' : ''}`}
    >
      <span className={desktopBar ? 'client-management-summary' : undefined}>
        Showing {start} - {end} of {totalCount} {resultsNoun}
      </span>
      <div className="mobile-clients-pagination-buttons">
        <button
          type="button"
          className="mobile-clients-page-button"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
        >
          Prev
        </button>
        {Array.from({ length: totalPages }).map((_, idx) => {
          const page = idx + 1;
          return (
            <button
              key={page}
              type="button"
              className={
                'mobile-clients-page-button' +
                (page === currentPage ? ' mobile-clients-page-button--active' : '')
              }
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          );
        })}
        <button
          type="button"
          className="mobile-clients-page-button"
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
        >
          Next
        </button>
      </div>
    </div>
  );
}
